export default __webpack_public_path__ + "static/image7-21ca0614600e058e651ea23ba35fd6dd.gif";